export const DATE_FMT_READABLE = 'MMM DD, YYYY';
export const DATE_FMT_SHORT = 'MM/DD/YYYY';
export const DATE_FMT_TIME = 'MMM DD, YYYY [at] hh:mm a';
